export function getCubeKey(value: string): string {
  if (!value) return '';
  const [key] = value.split('.');
  return key;
}
